import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: {
      fontSize: '1rem',
      '&.Mui-focused': {
        color: PrimaryColors.diamond,
      },
      '&.Mui-error': {
        color: PrimaryColors.radical,
      },
      '&.MuiFormLabel-filled, &.Mui-filled': {
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
    shrink: {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
};
